// Mirrors FulfillmentStatus.statusDisplay from FulfillmentStatus.swift
export const FULFILLMENT_STATUS = {
  orderPlaced: "Order Placed",
  inProgress: "In Progress",
  readyForPickup: "Ready for Pickup",
  pickedUp: "Picked Up",
  cancelled: "Cancelled",
};

export function getFulfillmentStatusLabel(status) {
  return FULFILLMENT_STATUS[status] || status;
}
